import { createSelector } from '@ngrx/store';

import { ValidationResponse } from '@models/swagger';
import { State } from './reducer';
import { selectValidateZipCodeState } from '../selectors';

export const getData = createSelector(selectValidateZipCodeState, (state: State) => state.data);

export const getError = createSelector(selectValidateZipCodeState, (state: State) => state.error);

export const getLoading = createSelector(selectValidateZipCodeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ValidationResponse) => T) =>
  createSelector(selectValidateZipCodeState, (state: State) => fn(state.data));
